import * as React from 'react'

export const ExternalLinkIcon = () => (
  <svg
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 16 16'
    width='16px'
    height='16px'
    className='inline pb-0.5'
  >
    <path d='M 9 2 L 9 3 L 12.292969 3 L 6.023438 9.273438 L 6.726563 9.976563 L 13 3.707031 L 13 7 L 14 7 L 14 2 Z M 4 4 C 2.894531 4 2 4.894531 2 6 L 2 12 C 2 13.105469 2.894531 14 4 14 L 10 14 C 11.105469 14 12 13.105469 12 12 L 12 7 L 11 8 L 11 12 C 11 12.550781 10.550781 13 10 13 L 4 13 C 3.449219 13 3 12.550781 3 12 L 3 6 C 3 5.449219 3.449219 5 4 5 L 8 5 L 9 4 Z' />
  </svg>
)
